import { render, staticRenderFns } from "./deptRetreatAddDialog.vue?vue&type=template&id=2fb4a6b2&scoped=true"
import script from "./deptRetreatAddDialog.vue?vue&type=script&lang=js"
export * from "./deptRetreatAddDialog.vue?vue&type=script&lang=js"
import style0 from "./deptRetreatAddDialog.vue?vue&type=style&index=0&id=2fb4a6b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb4a6b2",
  null
  
)

export default component.exports